import { Backdrop, Button, Card, CardContent, CardHeader, Checkbox, CircularProgress, Container, Divider, Grid, IconButton, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, TablePagination, Dialog, DialogTitle, DialogActions, DialogContent, List, ListItem, ListItemIcon, ListItemText, Typography, TableSortLabel } from '@mui/material';
import Alert from 'src/components/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Tarihce from 'src/views/History';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from 'date-fns/locale/tr';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'src/utils/axios';
import moment from 'moment';
import ExpandableComment from 'src/components/ExpandableComment';

const localeMap = {
  tr: trLocale
};

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650
  },
  content: {
    minHeight: 550
  },
  chatSection: {
    width: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1)
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }),
  actionsCCFile: {
    justifyContent: 'flex-end'
  },
  responsiveContainer: (theme) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'lg')]: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '60vh',
      overflow: 'scroll'
    }
  }),
  action: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: '16px',
    marginRight: '10px',
    borderRadius: 10,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: 0
    }
  })
};

function CloseConfirmReport() {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;

  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();
  

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [state, setState] = React.useState({
    kural1: false,
    kural2: false
  });

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = useState([]);
  const [selectedBolgeAdiKodu, setSelectedBolgeAdiKodu] = useState([]);

  const [durum, setDurum] = useState([]);
  const [selectedDurum, setSelectedDurum] = useState([]);

  const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
    new Date()
  );

  const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
    new Date()
  );

  const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY')
  const formattedBitisDate = moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY')

  const [generalData, setGeneralData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [tarihcePopUp, setTarihcePopUp] = useState(false);
  const [filePopUp, setFilePopUp] = useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('SURECTIPI');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const sortedRows = (stableSort(generalData, getComparator(order, orderBy)));
  const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    getBolgeAdiKoduData();
    getKapanisDurumData();
  }, []);

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKoduForReport`).then((response) => {
      setBolgeAdiKodu(response.data);
    })

  }

  const getKapanisDurumData = () => {
    axios.get("/GetKapanisDurum").then((response) => {
      setDurum(response.data);
    })
  }

  function GeneralDataFiltreleAra() {
    if (selectedDurum.length <= 0 || selectedBolgeAdiKodu.length <= 0) {
      setresponseMessage('Lütfen önce seçim yapınız!!!...')
      setUyariTip('error')
      setUyari(true)
      return
    }

    var BolgeAdiKoduList = [];
    selectedBolgeAdiKodu.map((i) => {
      BolgeAdiKoduList.push(i.BirimKodu)
    })

    var DurumlarList = [];
    selectedDurum.map((i) => {
      DurumlarList.push(i.DURUM)
    })

    const data = {
      BOLGEADIKODU: BolgeAdiKoduList.toString(),
      SONONAYVEREN: DurumlarList.toString(),
      BASLANGICTARIHI: formattedBaslangicDate,
      BITISTARIHI: formattedBitisDate,
    }

    axios.get(`GetCloseConfirmGenelDataAra/${data.BOLGEADIKODU}/${data.SONONAYVEREN}/${data.BASLANGICTARIHI}/${data.BITISTARIHI}`).then((response) => {
      setGeneralData(response.data);
      setPage(0);
    })
  }

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);        
};

  const handleYorum = (row) => {
    setSelectedIndex(row.ID);
    setTarihcePopUp(true);
  }

  const handleFilePopUp = (row) => {
    setSelectedIndex(row.ID);
    getReceiptAllFiles(row.ID)
    setFilePopUp(true);
  }

  const getReceiptAllFiles = (receiptNumber) => {
    setFileList([]);
    setLoading(true);
    if (!receiptNumber) {
      return;
    }
    var images = []
    axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 2).then(response => {
      setFileList(Array.isArray(response.data) ? response.data : [])
      setLoading(false)
    });
  }

  const setNewWindowOpen = (item) => {
    //get file data from GetReceiptFilesSpecial api
    setLoading(true);
    axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
      .then((response) => {
        const res = response.data[0];
        var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
        if (res?.DOSYA_TIPI?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          if (!w) {
            return;
          }
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
    // if (item?.DOSYA_TIPI?.includes('image')) {
    //   var image = new Image();
    //   image.src = FileData;
    //   var w = window.open("");
    //   w.document.write(image.outerHTML);
    //   w.document.title = item.DOSYA_ADI;
    //   w.document.close();
    // } else {
    //   var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
    //   openBlobInNewTab(blobData);
    // }
  }

  function descendingComparator(a, b, orderBy) {
    // Handle null values
    if (a[orderBy] === null && b[orderBy] !== null) {
        return 1; // Consider 'a' greater than 'b'
    } else if (a[orderBy] !== null && b[orderBy] === null) {
        return -1; // Consider 'b' greater than 'a'
    } else if (a[orderBy] === null && b[orderBy] === null) {
        return 0; // Both are null, consider them equal
    }
    if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] !== 'undefined') {
        return 1; // Consider 'a' greater than 'b'
    } else if (typeof a[orderBy] !== 'undefined' && typeof b[orderBy] === 'undefined') {
        return -1; // Consider 'b' greater than 'a'
    } else if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] === 'undefined') {
        return 0; // Both are null, consider them equal
    }
  
    // Handle comparison between string and integer values
    if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'string') {
        return 1; // Consider 'a' greater than 'b'
    } else if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'number') {
        return -1; // Consider 'b' greater than 'a'
    } else if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'number'){
      if(a[orderBy] < b[orderBy]){
        return -1;}
      else if(a[orderBy] > b[orderBy]){
        return 1;
      }
      else return 0;
    }
    
    return b[orderBy].localeCompare(a[orderBy]);
    
    
    // Compare non-null values using localeCompare
  }
  
  
  function getComparator(order, orderBy) {
    return order === 'desc'
       ? (a, b) => descendingComparator(a, b, orderBy)
       : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function stableSort(array, comparator) {
      if (array.length === 0){
      return array;
    }
    else{
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
    }
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    if (!newTab) {
      return;
    }
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }

  return (
    <Page sx={styles.root}>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container style={styles.container1} maxWidth="xl">
        <Card>
          <CardHeader title="Yetkili Servis Kapanış Durumları" />
          <Divider />
          <CardContent>
            <Grid container spacing={1} style={{ marginBottom: '5px' }}>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedBolgeAdiKodu}
                  options={bolgeAdiKodu}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setSelectedBolgeAdiKodu(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.BirimKodu == 0 ? option.Dsc : option.BirimKodu + ' - ' + option.Dsc}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Bölge Adı-Kodu"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedDurum}
                  options={durum}
                  getOptionLabel={option => (option.ACIKLAMA ? option.ACIKLAMA : '')}
                  onChange={(event, newValue) => {
                    setSelectedDurum(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.ACIKLAMA}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField {...params} label="Durum" variant="outlined" />
                  )}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={localeMap['tr']}
                >
                  <DatePicker
                    label={'Talep başlangıç tarihi'}
                    format={'dd.MM.yyyy'}
                    value={talepEdilmeBaslangicTarihi}
                    onChange={date => {
                      setTalepEdilmeBaslangicTarihi(date);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: 'small',
                        color: 'primary',
                        variant: 'outlined'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={localeMap['tr']}
                >
                  <DatePicker
                    label={'Talep bitiş tarihi'}
                    format={'dd.MM.yyyy'}
                    value={talepEdilmeBitisTarihi}
                    onChange={date => {
                      setTalepEdilmeBitisTarihi(date);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: 'small',
                        color: 'primary',
                        variant: 'outlined'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Button
                sx={styles.action}
                variant="contained"
                color="secondary"
                onClick={() => { GeneralDataFiltreleAra() }}
              >
                ARA
                <SearchIcon style={{ marginLeft: '5px' }} />
              </Button>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <TableContainer >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead style={{ overflowWrap: 'break-word' }}>
                  <TableRow>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'SURECTIPI' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'SURECTIPI'}
                        direction={orderBy === 'SURECTIPI' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('SURECTIPI')}}>
                        Kapanış Tipi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'BOLGEADIKODU' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'BOLGEADIKODU'}
                        direction={orderBy === 'BOLGEADIKODU' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('BOLGEADIKODU')}}>
                        Bölge Adı - Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'SONONAYVEREN' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'SONONAYVEREN'}
                        direction={orderBy === 'SONONAYVEREN' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('SONONAYVEREN')}}>
                        Son Onay Veren
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'ONAYBEKLEYEN' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'ONAYBEKLEYEN'}
                        direction={orderBy === 'ONAYBEKLEYEN' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('ONAYBEKLEYEN')}}>
                        Onay Beklenen
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'SERVISKODUADI' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'SERVISKODUADI'}
                        direction={orderBy === 'SERVISKODUADI' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('SERVISKODUADI')}}>
                        Servis Kodu-Adı
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'IL' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'IL'}
                        direction={orderBy === 'IL' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('IL')}}>
                        İl
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'ILCE' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'ILCE'}
                        direction={orderBy === 'ILCE' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('ILCE')}}>
                        İlçe
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'SERVIS_TIPI' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'SERVIS_TIPI'}
                        direction={orderBy === 'SERVIS_TIPI' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('SERVIS_TIPI')}}>
                        Servis Tipi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'SERVISBILGI' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'SERVISBILGI'}
                        direction={orderBy === 'SERVISBILGI' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('SERVISBILGI')}}>
                        Servis Bilgi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'FINDEKSYORUM' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'FINDEKSYORUM'}
                        direction={orderBy === 'FINDEKSYORUM' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('FINDEKSYORUM')}}>
                        Findeks Yorumu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left" 
                    sortDirection={orderBy === 'MERKEZ' ? order : false}>
                      <TableSortLabel
                        active={orderBy == 'MERKEZ'}
                        direction={orderBy === 'MERKEZ' ? order : 'asc'}
                        onClick={()=> {handleRequestSort('MERKEZ')}}>
                        Şube Merkezi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="left">Yorumlar</TableCell>
                    <TableCell align="left">Belgeler</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedRows.length > 0 && paginatedRows.map((row) => (
                    <TableRow
                      key={row.ID}
                      style={
                        row.ID === selectedIndex
                          ? { backgroundColor: '#FF9800' }
                          : {}
                      }
                    >
                      <TableCell align="left">{row.SURECTIPI}</TableCell>
                      <TableCell align="left">{row.BOLGEADIKODU}</TableCell>
                      <TableCell align="left">{row.SONONAYVEREN}</TableCell>
                      <TableCell align="left">{row.ONAYBEKLEYEN}</TableCell>
                      <TableCell align="left">{row.SERVISKODUADI}</TableCell>
                      <TableCell align="left">{row.IL}</TableCell>
                      <TableCell align="left">{row.ILCE}</TableCell>
                      <TableCell align="left">{row.SERVIS_TIPI}</TableCell>
                      <TableCell align="left">
                        <ExpandableComment
                          Comment={row.SERVISBILGI}
                          CommentLimit={100}
                          DarkColor={selectedIndex != row.ID ? false : true} />
                      </TableCell>
                      <TableCell align="left">{row.FINDEKSYORUM}</TableCell>
                      <TableCell align="left">{row.MERKEZ}</TableCell>
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleYorum(row)}
                          style={{ backgroundColor: '#19ecff', color: 'white' }}
                        >
                          <CommentOutlinedIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleFilePopUp(row)}
                          style={{ backgroundColor: '#FF7F00', color: 'white' }}
                        >
                          <AttachFileOutlinedIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left" />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={sortedRows.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage="Sayfa başına satır"
            />
          </CardContent>
          <Dialog
            open={tarihcePopUp}
            fullWidth
            maxWidth="lg"
            onClose={event => setTarihcePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
            <DialogContent>
              <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={2} />
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={event => setTarihcePopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={filePopUp}
            onClose={() => setFilePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Belgeler</DialogTitle>
            <DialogContent>
              {fileList?.length ? (
                <List dense>
                  {fileList.map((item) => (
                    <ListItem
                      key={item.DOSYA_ID}
                      onClick={() => setNewWindowOpen(item)}
                      sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                        mb: 1,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: 'rgba(255,152,0,0.06)' }
                      }}
                    >
                      <ListItemIcon>
                        <InsertDriveFileOutlinedIcon sx={{ color: '#FF9800' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.DOSYA_ADI}
                        secondary={item.ContentType}
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography sx={{ color: 'text.secondary', textAlign: 'center', py: 3 }}>
                  {loading ? 'Dosyalar yükleniyor...' : 'Dosya bulunmamaktadır.'}
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => {
                  setFilePopUp(false);
                }}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
        </Card>
      </Container>
    </Page>
  );
}
export default CloseConfirmReport;
